module.exports = __webpack_public_path__ + "static/media/SEVEN.d4efc1a3.png";